var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "placeholder placeholder_inline placeholder_icon placeholder_date",
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [
          _vm._v("\n        " + _vm._s(_vm.formattedDate) + "\n\n        "),
          _vm._t("default"),
          _vm._v(" "),
          _c("Icon", { attrs: { id: "arrow-down" } }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.open
        ? _c("DatePicker", {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.close,
                expression: "close",
              },
            ],
            attrs: {
              inline: true,
              value: _vm.value,
              clearable: false,
              "disabled-date": _vm.disabledTo(_vm.minDate),
            },
            on: { input: (v) => _vm.$emit("input", v), change: _vm.close },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }